<template>
    <mks-spacer spacing="s">
      <mks-heading tag="h3" tag-class="h6">{{title}}</mks-heading>
      <slot></slot>
    </mks-spacer>
</template>
<script>
export default {
    props: {
        title: String
    }
}
</script>